// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__2x2eq","ps":"About_ps__1UL9r","red":"About_red__3ElQP","arrow":"About_arrow__984OP","animate":"About_animate__2p691","fade":"About_fade__19Ep-"};